"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _QueryIntegration_instances, _QueryIntegration_api, _QueryIntegration_getTimeoutMinutes, _QueryIntegration_getRetryIntervalSeconds, _QueryIntegration_getMaxAgeMinutes, _QueryIntegration_getTTLHours, _QueryIntegration_createQuery, _QueryIntegration_getQueryRunInLoop;
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryIntegration = void 0;
const types_1 = require("../../types");
const sleep_1 = require("../../utils/sleep");
const errors_1 = require("../../errors");
const query_result_set_builder_1 = require("./query-result-set-builder");
const defaults_1 = require("../../defaults");
class QueryIntegration {
    constructor(api) {
        _QueryIntegration_instances.add(this);
        _QueryIntegration_api.set(this, void 0);
        __classPrivateFieldSet(this, _QueryIntegration_api, api, "f");
    }
    run(query) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            let createQueryRunParams = {
                resultTTLHours: __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_getTTLHours).call(this, query),
                sql: query.sql,
                maxAgeMinutes: __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_getMaxAgeMinutes).call(this, query),
                tags: {
                    sdk_language: "javascript",
                    sdk_package: query.sdkPackage ? query.sdkPackage : defaults_1.DEFAULTS.sdkPackage,
                    sdk_version: query.sdkVersion ? query.sdkVersion : defaults_1.DEFAULTS.sdkVersion,
                },
                dataSource: query.dataSource ? query.dataSource : defaults_1.DEFAULTS.dataSource,
                dataProvider: query.dataProvider ? query.dataProvider : defaults_1.DEFAULTS.dataProvider,
            };
            const createQueryRunRpcResponse = yield __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_createQuery).call(this, createQueryRunParams);
            if (createQueryRunRpcResponse.error) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: (0, errors_1.getExceptionByErrorCode)(createQueryRunRpcResponse.error.code, createQueryRunRpcResponse.error.message),
                });
            }
            if (!((_a = createQueryRunRpcResponse.result) === null || _a === void 0 ? void 0 : _a.queryRun)) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: new errors_1.UnexpectedSDKError("expected a `createQueryRunRpcResponse.result.queryRun` but got null"),
                });
            }
            // loop to get query state
            const [queryRunRpcResp, queryError] = yield __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_getQueryRunInLoop).call(this, {
                queryRunId: (_b = createQueryRunRpcResponse.result) === null || _b === void 0 ? void 0 : _b.queryRun.id,
                timeoutMinutes: __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_getTimeoutMinutes).call(this, query),
                retryIntervalSeconds: __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_getRetryIntervalSeconds).call(this, query),
            });
            if (queryError) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: queryError,
                });
            }
            if (queryRunRpcResp && queryRunRpcResp.error) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: (0, errors_1.getExceptionByErrorCode)(queryRunRpcResp.error.code, queryRunRpcResp.error.message),
                });
            }
            const queryRun = (_c = queryRunRpcResp === null || queryRunRpcResp === void 0 ? void 0 : queryRunRpcResp.result) === null || _c === void 0 ? void 0 : _c.queryRun;
            if (!queryRun) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: new errors_1.UnexpectedSDKError("expected a `queryRunRpcResp.result.queryRun` but got null"),
                });
            }
            // get the query results
            const queryResultResp = yield __classPrivateFieldGet(this, _QueryIntegration_api, "f").getQueryResult({
                queryRunId: queryRun.id,
                format: types_1.ResultFormat.csv,
                page: {
                    number: query.pageNumber || 1,
                    size: query.pageSize || 100000,
                },
            });
            if (queryResultResp && queryResultResp.error) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: (0, errors_1.getExceptionByErrorCode)(queryResultResp.error.code, queryResultResp.error.message),
                });
            }
            const queryResults = queryResultResp.result;
            if (!queryResults) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: new errors_1.UnexpectedSDKError("expected a `queryResultResp.result` but got null"),
                });
            }
            return new query_result_set_builder_1.QueryResultSetBuilder({
                getQueryRunResultsRpcResult: queryResults,
                getQueryRunRpcResult: queryRunRpcResp.result,
                error: null,
            });
        });
    }
    getQueryResults({ queryRunId, pageNumber = defaults_1.DEFAULTS.pageNumber, pageSize = defaults_1.DEFAULTS.pageSize, filters, sortBy, }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const queryRunResp = yield __classPrivateFieldGet(this, _QueryIntegration_api, "f").getQueryRun({ queryRunId });
            if (queryRunResp.error) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: (0, errors_1.getExceptionByErrorCode)(queryRunResp.error.code, queryRunResp.error.message),
                });
            }
            if (!queryRunResp.result) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: new errors_1.UnexpectedSDKError("expected an `rpc_response.result` but got null"),
                });
            }
            if (!((_a = queryRunResp.result) === null || _a === void 0 ? void 0 : _a.queryRun)) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: new errors_1.UnexpectedSDKError("expected an `rpc_response.result.queryRun` but got null"),
                });
            }
            const queryRun = queryRunResp.result.redirectedToQueryRun
                ? queryRunResp.result.redirectedToQueryRun
                : queryRunResp.result.queryRun;
            const queryResultResp = yield __classPrivateFieldGet(this, _QueryIntegration_api, "f").getQueryResult({
                queryRunId: queryRun.id,
                format: types_1.ResultFormat.csv,
                page: {
                    number: pageNumber,
                    size: pageSize,
                },
                filters,
                sortBy,
            });
            if (queryResultResp.error) {
                return new query_result_set_builder_1.QueryResultSetBuilder({
                    error: (0, errors_1.getExceptionByErrorCode)(queryResultResp.error.code, queryResultResp.error.message),
                });
            }
            return new query_result_set_builder_1.QueryResultSetBuilder({
                getQueryRunResultsRpcResult: queryResultResp.result,
                getQueryRunRpcResult: queryRunResp.result,
                error: null,
            });
        });
    }
    createQueryRun(query) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let createQueryRunParams = {
                resultTTLHours: __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_getTTLHours).call(this, query),
                sql: query.sql,
                maxAgeMinutes: __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_getMaxAgeMinutes).call(this, query),
                tags: {
                    sdk_language: "javascript",
                    sdk_package: query.sdkPackage ? query.sdkPackage : defaults_1.DEFAULTS.sdkPackage,
                    sdk_version: query.sdkVersion ? query.sdkVersion : defaults_1.DEFAULTS.sdkVersion,
                },
                dataSource: query.dataSource ? query.dataSource : defaults_1.DEFAULTS.dataSource,
                dataProvider: query.dataProvider ? query.dataProvider : defaults_1.DEFAULTS.dataProvider,
            };
            const createQueryRunRpcResponse = yield __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_createQuery).call(this, createQueryRunParams);
            if (createQueryRunRpcResponse.error) {
                throw (0, errors_1.getExceptionByErrorCode)(createQueryRunRpcResponse.error.code, createQueryRunRpcResponse.error.message);
            }
            if (!((_a = createQueryRunRpcResponse.result) === null || _a === void 0 ? void 0 : _a.queryRun)) {
                throw new errors_1.UnexpectedSDKError("expected a `createQueryRunRpcResponse.result.queryRun` but got null");
            }
            return createQueryRunRpcResponse.result.queryRun;
        });
    }
    getQueryRun({ queryRunId }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield __classPrivateFieldGet(this, _QueryIntegration_api, "f").getQueryRun({ queryRunId });
            if (resp.error) {
                throw (0, errors_1.getExceptionByErrorCode)(resp.error.code, resp.error.message);
            }
            if (!resp.result) {
                throw new errors_1.UnexpectedSDKError("expected an `rpc_response.result` but got null");
            }
            if (!((_a = resp.result) === null || _a === void 0 ? void 0 : _a.queryRun)) {
                throw new errors_1.UnexpectedSDKError("expected an `rpc_response.result.queryRun` but got null");
            }
            return resp.result.redirectedToQueryRun ? resp.result.redirectedToQueryRun : resp.result.queryRun;
        });
    }
    getSqlStatement({ sqlStatementId }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield __classPrivateFieldGet(this, _QueryIntegration_api, "f").getSqlStatement({ sqlStatementId });
            if (resp.error) {
                throw (0, errors_1.getExceptionByErrorCode)(resp.error.code, resp.error.message);
            }
            if (!resp.result) {
                throw new errors_1.UnexpectedSDKError("expected an `rpc_response.result` but got null");
            }
            if (!((_a = resp.result) === null || _a === void 0 ? void 0 : _a.sqlStatement)) {
                throw new errors_1.UnexpectedSDKError("expected an `rpc_response.result.sqlStatement` but got null");
            }
            return resp.result.sqlStatement;
        });
    }
    cancelQueryRun({ queryRunId }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield __classPrivateFieldGet(this, _QueryIntegration_api, "f").cancelQueryRun({ queryRunId });
            if (resp.error) {
                throw (0, errors_1.getExceptionByErrorCode)(resp.error.code, resp.error.message);
            }
            if (!resp.result) {
                throw new errors_1.UnexpectedSDKError("expected an `rpc_response.result` but got null");
            }
            if (!((_a = resp.result) === null || _a === void 0 ? void 0 : _a.canceledQueryRun)) {
                throw new errors_1.UnexpectedSDKError("expected an `rpc_response.result.canceledQueryRun` but got null");
            }
            return resp.result.canceledQueryRun;
        });
    }
}
exports.QueryIntegration = QueryIntegration;
_QueryIntegration_api = new WeakMap(), _QueryIntegration_instances = new WeakSet(), _QueryIntegration_getTimeoutMinutes = function _QueryIntegration_getTimeoutMinutes(query) {
    return query.timeoutMinutes ? query.timeoutMinutes : defaults_1.DEFAULTS.timeoutMinutes;
}, _QueryIntegration_getRetryIntervalSeconds = function _QueryIntegration_getRetryIntervalSeconds(query) {
    return query.retryIntervalSeconds ? Number(query.retryIntervalSeconds) : defaults_1.DEFAULTS.retryIntervalSeconds;
}, _QueryIntegration_getMaxAgeMinutes = function _QueryIntegration_getMaxAgeMinutes(query) {
    if (query.cached === false) {
        return 0;
    }
    return query.maxAgeMinutes ? query.maxAgeMinutes : defaults_1.DEFAULTS.maxAgeMinutes;
}, _QueryIntegration_getTTLHours = function _QueryIntegration_getTTLHours(query) {
    const maxAgeMinutes = __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_getMaxAgeMinutes).call(this, query);
    const ttlMinutes = maxAgeMinutes > 60 ? maxAgeMinutes : defaults_1.DEFAULTS.ttlMinutes;
    return Math.floor(ttlMinutes / 60);
}, _QueryIntegration_createQuery = function _QueryIntegration_createQuery(params, attempts = 0) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield __classPrivateFieldGet(this, _QueryIntegration_api, "f").createQuery(params);
    });
}, _QueryIntegration_getQueryRunInLoop = function _QueryIntegration_getQueryRunInLoop({ queryRunId, timeoutMinutes, retryIntervalSeconds, attempts = 0, }) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        let resp = yield __classPrivateFieldGet(this, _QueryIntegration_api, "f").getQueryRun({ queryRunId });
        if (resp.error) {
            return [null, (0, errors_1.getExceptionByErrorCode)(resp.error.code, resp.error.message)];
        }
        const queryRun = ((_a = resp.result) === null || _a === void 0 ? void 0 : _a.redirectedToQueryRun) ? resp.result.redirectedToQueryRun : (_b = resp.result) === null || _b === void 0 ? void 0 : _b.queryRun;
        if (!queryRun) {
            return [null, new errors_1.UnexpectedSDKError("expected an `rpc_response.result.queryRun` but got null")];
        }
        const queryRunState = (0, types_1.mapApiQueryStateToStatus)(queryRun.state);
        if (queryRunState === types_1.QueryStatusFinished) {
            return [resp, null];
        }
        if (queryRunState === types_1.QueryStatusError) {
            return [
                null,
                new errors_1.QueryRunExecutionError({
                    name: queryRun.errorName,
                    message: queryRun.errorMessage,
                    data: queryRun.errorData,
                }),
            ];
        }
        let shouldContinue = yield (0, sleep_1.linearBackOff)({
            attempts,
            timeoutMinutes,
            intervalSeconds: retryIntervalSeconds,
        });
        if (!shouldContinue) {
            const elapsedSeconds = (0, sleep_1.getElapsedLinearSeconds)({
                attempts,
                timeoutMinutes,
                intervalSeconds: retryIntervalSeconds,
            });
            return [null, new errors_1.QueryRunTimeoutError(elapsedSeconds * 60)];
        }
        return __classPrivateFieldGet(this, _QueryIntegration_instances, "m", _QueryIntegration_getQueryRunInLoop).call(this, { queryRunId, attempts: attempts + 1, timeoutMinutes, retryIntervalSeconds });
    });
};
//# sourceMappingURL=index.js.map